import React, { useState } from "react";
import Results from "./Results";
import Photos from "./Photos";
import axios from "axios";
import "./Dictionary.css";

export default function Dictionary(props) {
    let [keyword, setKeyword] = useState(props.defaultKeyword); //this is getting props from app.js component
    let [results, setResults] = useState(null);
    let [loaded, setLoaded] = useState(false);
    let [photos, setPhotos] = useState(null);
    
    function handleSubmit(event) {
        event.preventDefault();
        search();
    }

    function search(){
        let apiURL = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${keyword}`;
        axios.get(apiURL).then(handleDictionaryResponse);

        let pexelsAPIKey = "563492ad6f917000010000011a6d8119a03e4803a48901f7c828449e";
        let pexelsAPIURL = `https://api.pexels.com/v1/search?query=${keyword}&per_page=6`;
        let headers = {Authorization: `Bearer ${pexelsAPIKey}`};
        axios.get(pexelsAPIURL, {headers: headers}).then(handlePexelsResponse);
    }

    function handlePexelsResponse(response){
        setPhotos(response.data.photos);
    }

    function handleDictionaryResponse(response) {
        setResults(response.data[0]);
    }

    function handleKeywordChange(event) {
        setKeyword(event.target.value);
    }

    function load(){
        setLoaded(true);
        search();
    }

    if(loaded) {
        return (
        <div className = "Dictionary">
            <div className = "container">
                <section>
                    <form onSubmit={handleSubmit}>
                        <input type="search" autoFocus="on" onChange={handleKeywordChange} />
                        <div className="hint">
                            suggested words: wine, cup, phone, book etc.
                        </div>
                    </form>
                </section>
                <Results results={results}/>
                <Photos photos={photos} />
            </div>  
        </div>
        )
    } else {
        load();
        return null;
    }
    
}